/* ============================================================
   Menus de l'en-tete — generalise aux 3 declencheurs
   (Boutique, Resultats, Safranotherapie) via data-menu-trigger.
   L'etat vivant est porte par .header[data-menu="<id du panneau>"].
   ============================================================ */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;

  var triggers = [].slice.call(header.querySelectorAll('[data-menu-trigger]'));

  function panneau(t) { return document.getElementById(t.getAttribute('data-menu-trigger')); }

  function fermerTout() {
    header.removeAttribute('data-menu');
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var p = panneau(t);
      if (p) p.setAttribute('inert', '');
    });
  }

  function ouvrir(t) {
    var p = panneau(t);
    fermerTout();                         // survoler un autre onglet ferme le precedent
    if (!p) return;                       // pas de panneau rattache : rien a ouvrir
    header.setAttribute('data-menu', t.getAttribute('data-menu-trigger'));
    t.setAttribute('aria-expanded', 'true');
    p.removeAttribute('inert');
  }

  function estOuvert(t) {
    return header.getAttribute('data-menu') === t.getAttribute('data-menu-trigger');
  }

  /* Ouverture au survol seulement si la souris a vraiment bouge vers l'onglet (08/10) :
     au chargement d'une page, le curseur reste souvent sur « Boutique » et le menu s'ouvrait tout seul. */
  var souris = false, attente = null;
  document.addEventListener('mousemove', function (e) {
    if (!e.target.closest || !e.target.closest('[data-menu-trigger]')) souris = true;
  }, { passive: true });
  triggers.forEach(function (t) {
    t.addEventListener('mouseenter', function () {
      if (!souris) return;
      clearTimeout(attente);
      attente = setTimeout(function () { ouvrir(t); }, 120);
    });
    t.addEventListener('mouseleave', function () { clearTimeout(attente); });
    t.addEventListener('focus', function () { if (t.matches(':focus-visible')) ouvrir(t); });
    t.addEventListener('click', function (e) {
      e.preventDefault();
      if (estOuvert(t)) { fermerTout(); } else { ouvrir(t); }
    });
    t.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        e.preventDefault();
        if (estOuvert(t)) { fermerTout(); } else { ouvrir(t); }
      }
    });
  });

  header.addEventListener('mouseleave', fermerTout);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && header.hasAttribute('data-menu')) {
      var actif = triggers.filter(estOuvert)[0];
      fermerTout();
      if (actif) actif.focus();
    }
  });
  header.addEventListener('focusout', function (e) {
    if (!header.contains(e.relatedTarget)) fermerTout();
  });

  /* --- Carrousels des panneaux --- */
  [].forEach.call(document.querySelectorAll('.mm__carousel'), function (car) {
    var vp = car.querySelector('.mm__viewport');
    var slide = car.querySelector('.mm__slide');
    if (!vp || !slide) return;
    var step = slide.getBoundingClientRect().width + 16;
    var prev = car.querySelector('.mm__nav--prev');
    var next = car.querySelector('.mm__nav--next');
    if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step, behavior: 'smooth' }); });
  });

  /* --- Burger mobile --- */
  var burger = document.querySelector('.mm-burger');
  var mobilePanel = document.getElementById('mm-burger-panel');
  var lastFocused = null;

  function fermerMobile(options) {
    if (!burger || !mobilePanel) return;
    var wasOpen = burger.getAttribute('aria-expanded') === 'true';
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', 'Ouvrir le menu');
    header.removeAttribute('data-burger');
    mobilePanel.setAttribute('inert', '');
    document.body.classList.remove('menu-mobile-ouvert');
    if (wasOpen && options && options.restoreFocus) {
      (lastFocused || burger).focus();
    }
  }

  function ouvrirMobile() {
    if (!burger || !mobilePanel) return;
    fermerTout();
    lastFocused = document.activeElement;
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', 'Fermer le menu');
    header.setAttribute('data-burger', 'open');
    mobilePanel.removeAttribute('inert');
    document.body.classList.add('menu-mobile-ouvert');
  }

  if (burger && mobilePanel) {
    burger.setAttribute('aria-label', 'Ouvrir le menu');
    fermerMobile();
    burger.addEventListener('click', function () {
      if (burger.getAttribute('aria-expanded') === 'true') fermerMobile();
      else ouvrirMobile();
    });

    mobilePanel.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) fermerMobile();
    });

    document.addEventListener('click', function (e) {
      if (burger.getAttribute('aria-expanded') !== 'true') return;
      if (!header.contains(e.target)) fermerMobile();
    });

    document.addEventListener('keydown', function (e) {
      if (burger.getAttribute('aria-expanded') !== 'true') return;
      if (e.key === 'Escape') {
        e.preventDefault();
        fermerMobile({ restoreFocus: true });
        return;
      }
      if (e.key !== 'Tab') return;
      var focusables = [burger].concat([].slice.call(mobilePanel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )));
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1150) fermerMobile();
    });
  }

  /* --- Accordeon du panneau mobile --- */
  [].forEach.call(document.querySelectorAll('.mm-acc__toggle'), function (t) {
    t.addEventListener('click', function () {
      t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
  });

  /* --- Liens hors perimetre : inertes, mais signales --- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a.is-hors-perimetre') : null;
    if (a) e.preventDefault();
  });

  fermerTout();
})();
